import React, { Component } from 'react';
import { Row, Column } from 'simple-flexbox';
import { Panel, Button } from "react-bootstrap";
import { withTranslation } from 'react-i18next';

import Alert from "@modules/Alert";
import ComponentHeader from "@components/componentHeader";
import Form from "@sm/core/Form";
import Spinner from '@components/Spinner';
import WalletInfo from './WalletInfo';

import ReportIcon from '@assets/images/report.png';
import ReportIconTrustbucks from '@assets/images/trustbucks/report.png';
import ReportIconT365 from '@assets/images/t365/report.png';
import ReportIconPacificCapital from '@assets/images/pacificCapital/report.png';

import '@assets/css/myAccount.css';

import { crudActions } from "@sm/services/crudActions";
import { whiteLabel } from '@sm/config';
import { getColor } from "@sm/utils/utils";

class MyAccount extends Component {
  state = {
    accountForm: new Form({
      name: "",
      phone: "",
      skype: "",
      currentPassword: null,
      newPassword: null,
      walletCurrency: "",
      walletAddress: "",
      lasUpdateDate: ""
    }, [{
      name: "name",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "phone",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "skype",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "currentPassword",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "newPassword",
      type: "isPattern",
      rules: {
        required: false,
        pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})",
        customErrorMessage: "Password must contain at least 1 lowercase alphabetical character, 1 uppercase alphabetical character, 1 numeric character, 1 special character and must be 8 characters or longer"
      }
    }, {
      name: "walletCurrency",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "walletAddress",
      type: "isString",
      rules: {
        required: false
      }
    }]),

    username: "",
    role: "",
    whiteLabels: "",
    merchants: "",
    companyId: null,
    merchantId: null,
    otcCurrencies: [],

    confirmPassword: "",
    confirmPasswordTouched: false,
    showAlert: false,
    alertType: "success",
    alertMessage: "",
    isLoading: true,
    submitClicked: false,
    isSubmitting: false,

    //temporary
    currentLanguage: "en"
  };

  componentDidMount() {
    const { accountForm } = this.state;

    Promise.all([
      crudActions.get(`v1/myaccount`),
      crudActions.get(`v1/clients/current`)
    ]).then(
      (response) => {
        const accountData = response[0];
        const current = response[1];
        if (current) {
          this.setState({
            companyId: current.companyId
          });
        }
        if (accountData) {
          this.setState({
            accountForm: Object.assign(accountForm, {
              name: accountData.name,
              phone: accountData.phone,
              skype: accountData.skype
            }),
            username: accountData.username,
            role: accountData.role,
            whiteLabels: accountData.whiteLabels.join(", "),
            merchants: accountData.merchants.join(", "),
            merchantId: accountData.merchantId,
            otcCurrencies: accountData.walletCurrencies,
            isLoading: false
          });
        }
      }
    ).catch(
      (err) => {
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message
          });
        }
      }
    );
  };

  onValueChange = (event, fieldName) => {
    let { accountForm } = this.state;
    const { submitClicked } = this.state;
    accountForm = Object.assign(accountForm, {
      [fieldName]: event.target.value
    });

    if (submitClicked) {
      accountForm.isFormValid();
    }

    this.setState({
      accountForm: accountForm
    });
  };

  onConfirmPasswordChange = (event) => {
    this.setState({
      confirmPassword: event.target.value,
      confirmPasswordTouched: true
    });
  };

  arePasswordsIdentical = () => {
    const { accountForm, confirmPassword } = this.state;

    if (!accountForm.currentPassword && !accountForm.newPassword) {
      return true;
    }

    return accountForm.newPassword === confirmPassword;
  };

  submitAccountSettings = () => {
    const { accountForm } = this.state;
    const isFormValid = accountForm.isFormValid();
    this.setState({
      accountForm: accountForm,
      confirmPasswordTouched: true,
      submitClicked: true
    });

    if (isFormValid && this.arePasswordsIdentical()) {
      this.setState({
        isSubmitting: true
      });
      const data = Object.assign(accountForm.data(), {
        fullName: accountForm.name
      });
      delete data.lasUpdateDate;
      crudActions.put(`v1/myaccount`, data).then(
        () => {
          this.setState({
            showAlert: true,
            alertType: "success",
            alertMessage: "Your data was successfully updated.",
            isSubmitting: false
          });
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message,
              isSubmitting: false
            });
          }
        }
      );
    }
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
      alertType: "success",
      alertMessage: ""
    });
  };

  getIcon = () => {
    switch (whiteLabel) {
    case "t365":
      return ReportIconT365;
    case "pacificCapital":
      return ReportIconPacificCapital;
    case "trustbucks":
      return ReportIconTrustbucks;
    default:
      return ReportIcon;
    }
  };

  render() {
    const { accountForm, confirmPassword, confirmPasswordTouched, username, isLoading,
      role, whiteLabels, merchants, showAlert, alertMessage, alertType, isSubmitting,
      otcCurrencies, merchantId, companyId } = this.state;
    const { t } = this.props;

    return (
      <Row flexGrow={ 1 } className={ `${whiteLabel} module apidata my-account` } vertical='start'>
        <Column flexGrow={ 1 }>
          <ComponentHeader
            title="My Account"
            img={ this.getIcon() } />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    USER INFO
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <form autoComplete="off">
                    <input type="password" autoComplete="new-password" style={ { display: "none" } }/>
                    { isLoading ? (
                      <div style={ { width: "100%", height: "200px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                        <Spinner smallContainer={ true } />
                      </div>
                    ) : (
                      <div className="panel-content" style={ {overflow: 'unset'} }>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Full Name </label>
                              <input
                                className={ "form-control " + (accountForm.errors.has('name') ? 'error-field' : '') }
                                value={ accountForm.name || '' }
                                onChange={ (e) => this.onValueChange(e, "name") }/>
                              { accountForm.errors.has('name') && <p className="error-message"> { accountForm.errors.get('name') } </p> }
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Phone </label>
                              <input
                                className={ "form-control " + (accountForm.errors.has('phone') ? 'error-field' : '') }
                                value={ accountForm.phone || '' }
                                onChange={ (e) => this.onValueChange(e, "phone") }/>
                              { accountForm.errors.has('phone') && <p className="error-message"> { accountForm.errors.get('phone') } </p> }
                            </Column>
                          </Row>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Skype </label>
                              <input
                                className={ "form-control " + (accountForm.errors.has('skype') ? 'error-field' : '') }
                                value={ accountForm.skype || '' }
                                onChange={ (e) => this.onValueChange(e, "skype") }/>
                              { accountForm.errors.has('skype') && <p className="error-message"> { accountForm.errors.get('skype') } </p> }
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Email/username </label>
                              <input
                                className="form-control"
                                disabled
                                value={ username || '' }/>
                            </Column>
                          </Row>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <h5 className="change-password-title"> CHANGE PASSWORD </h5>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Current Password </label>
                              <input
                                type="password"
                                className={ "form-control " + (accountForm.errors.has('currentPassword') ? 'error-field' : '') }
                                value={ accountForm.currentPassword || '' }
                                onChange={ (e) => this.onValueChange(e, "currentPassword") }/>
                              { accountForm.errors.has('currentPassword') && <p className="error-message"> { accountForm.errors.get('currentPassword') } </p> }
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> New Password </label>
                              <input
                                type="password"
                                className={ "form-control " + (accountForm.errors.has('newPassword') ? 'error-field' : '') }
                                value={ accountForm.newPassword || '' }
                                onChange={ (e) => this.onValueChange(e, "newPassword") }/>
                              { accountForm.errors.has('newPassword') && <p className="error-message"> { accountForm.errors.get('newPassword') } </p> }
                            </Column>
                          </Row>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='end' alignSelf='start' className="input-column">
                              <label> New Password Again </label>
                              <input
                                type="password"
                                className={ "form-control " + (!this.arePasswordsIdentical() && confirmPasswordTouched ? 'error-field' : '') }
                                value={ confirmPassword || '' }
                                onChange={ (e) => this.onConfirmPasswordChange(e) }/>
                              { !this.arePasswordsIdentical() && confirmPasswordTouched && <p className="error-message">
                                { !confirmPassword ? "Please, confirm the password."  : "Passwords are not identical." } </p>}
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <span/>
                            </Column>
                          </Row>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <h5 className="change-password-title"> ACCESS </h5>
                          </Column>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> User Level </label>
                              <input
                                className="form-control"
                                disabled
                                value={ t(role, { framework: "react-i18next" }) || '' }/>
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> White Label </label>
                              <input
                                className="form-control"
                                disabled
                                value={ whiteLabels || '' }/>
                            </Column>
                          </Row>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' alignSelf='start'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <span/>
                            </Column>
                            <Column flexGrow={ 1 } vertical='end' alignSelf='end' className="input-column">
                              <label style={ { visibility: "hidden" } }>Save</label>
                              <Button
                                className="btn defaultBtn"
                                disabled={ isSubmitting }
                                onClick={ this.submitAccountSettings }>
                              Save
                              </Button>
                            </Column>
                          </Row>
                        </Row>
                      </div>
                    )}
                  </form>
                </Panel.Body>
              </Panel>
              {otcCurrencies.length > 0 && (
                <WalletInfo
                  otcCurrencies={ otcCurrencies }
                  companyId={ companyId }
                  merchantId={ merchantId }
                />
              )}

            </Column>
          </Row>
        </Column>

        {showAlert && (
          <Alert
            show={ showAlert }
            title={ alertType }
            type={ alertType }
            text={ alertMessage }
            confirmButtonColor={ getColor(whiteLabel) }
            onConfirm={ this.onConfirm }
          />
        )}
        
      </Row>
    );
  }
}

export default withTranslation("common")(MyAccount);
